export default [
  {
    path: '/admission-topic/index',
    name: 'index',
    component: () => import('@/views/admission-topic/index'),
    meta: {
      title: '高考录取指南'
    }
  },
  {
    path: '/admission-topic/timeline',
    name: 'timeline',
    component: () => import('@/views/admission-topic/timeline'),
    meta: {
      title: '高考录取指南'
    }
  },
  {
    path: '/admission-topic/news',
    name: 'news',
    component: () => import('@/views/admission-topic/news'),
    meta: {
      title: '高考录取指南'
    }
  },
]